import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DangerAlert, SuccessAlert } from '@tmapy/style-guide';

import { QUERY_STATE } from '../../constants';
import { useFormItemServerErrors } from '../../hooks';
import type { ServerErrors } from '../../types';

import { serviceOrderFormMessages } from './serviceOrderMessages';

type ServiceOrderSaveAlertsProps = {
  queryState: QUERY_STATE;
  serverErrors?: ServerErrors | null;
  isSuccessVisible?: boolean;
};

/** Chyby polí ukazuje formulář u polí, sem patří jen výsledek odeslání jako celku. */
export const ServiceOrderSaveAlerts: React.FC<ServiceOrderSaveAlertsProps> = ({
  queryState,
  serverErrors,
  isSuccessVisible = false,
}) => {
  const formItemServerErrors = useFormItemServerErrors(serverErrors);

  return (
    <>
      {formItemServerErrors.non_field_errors?.errorMessage && (
        <DangerAlert>{formItemServerErrors.non_field_errors.errorMessage}</DangerAlert>
      )}
      {queryState === QUERY_STATE.SUCCESS && isSuccessVisible && (
        <SuccessAlert>
          <FormattedMessage {...serviceOrderFormMessages.submitSuccess} />
        </SuccessAlert>
      )}
      {queryState === QUERY_STATE.FAIL && !serverErrors && (
        <DangerAlert>
          <FormattedMessage {...serviceOrderFormMessages.submitFail} />
        </DangerAlert>
      )}
    </>
  );
};
